export default {
    idCard(idCard) {
        if (!idCard) {
            return ""
        }
        if (idCard.length !== 18) {
            return "格式不正确";
        }
        let newIdCard = idCard.substring(0, 4) + "******" + idCard.substring(14);
        return newIdCard;
    },
    phone(phone) {
        if (!phone) {
            return ""
        }
        let newl = phone.length - 7
        let s = new Array(newl + 1).join("*");
        return phone.substring(0, 3) + s + phone.substring(7);
    },
    name(name) {
        if (!name) {
            return ""
        }
        if (name.length == 2) {
            return name.substring(0, 1) + "*"
        }
        let s = new Array(name.length - 2 + 1).join("*");
        return name.substring(0, 1) + s + name.substring(name.length - 1)
    }
}